var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { DefaultInputProps } from '../model/DefaultInputProps';
import { CustomInputForm } from './Forms/CustomInputForm';
import { IconButton, InputAdornment, MenuItem } from '@mui/material';
import { ShowContent } from './ShowContent';
import { isEmpty, nonNull } from '../util/CommonUtils';
import ClearIcon from '@mui/icons-material/Clear';
var DefaultDropDownProps = /** @class */ (function (_super) {
    __extends(DefaultDropDownProps, _super);
    function DefaultDropDownProps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DefaultDropDownProps;
}(DefaultInputProps));
export var DefaultDropDown = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "Selecione um Projeto Fundi\u00E1rio" : _b, _c = _a.noOptionsText, noOptionsText = _c === void 0 ? 'Nenhum registro encontrado.' : _c, defaultValue = _a.defaultValue, fieldError = _a.fieldError, _d = _a.values, values = _d === void 0 ? [] : _d, onChange = _a.onChange, disabled = _a.disabled, label = _a.label, value = _a.value, name = _a.name, required = _a.required;
    var error = useMemo(function () {
        return fieldError ? fieldError["".concat(name, "Error")] : '';
    }, [fieldError, name]);
    useEffect(function () {
    }, []);
    var renderPlaceHolder = function (selected) {
        var _a;
        if (!selected) {
            return (_jsx("span", __assign({ style: { color: '#9e9e9e' } }, { children: placeholder })));
        }
        var option = (values !== null && values !== void 0 ? values : []).find(function (it) { return (it === null || it === void 0 ? void 0 : it.value) === selected; });
        return (_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '';
    };
    var handleClear = function (event) {
        event.stopPropagation();
        onChange(undefined);
    };
    var clearButton = function () {
        return (_jsx(ShowContent, __assign({ show: (!disabled && nonNull(value)) }, { children: _jsx(InputAdornment, __assign({ position: "end", style: { position: 'absolute', right: '26px' } }, { children: _jsx(IconButton, __assign({ size: "small", onClick: handleClear, tabIndex: -1 }, { children: _jsx(ClearIcon, { fontSize: "small" }) })) })) })));
    };
    return (_jsxs(CustomInputForm, __assign({ onChange: function (event) { var _a, _b; return onChange(((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) ? (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value : null); }, InputLabelProps: { shrink: true }, SelectProps: {
            renderValue: function (selected) { return renderPlaceHolder(selected); },
            displayEmpty: true,
        }, defaultValue: defaultValue, InputProps: {
            endAdornment: clearButton()
        }, placeholder: placeholder, disabled: disabled, required: required, value: value !== null && value !== void 0 ? value : '', helperText: error, variant: "outlined", error: !!error, label: label, name: name, id: name, fullWidth: true, select: true }, { children: [_jsx(ShowContent, __assign({ show: (values === null || values === void 0 ? void 0 : values.length) === 0 }, { children: _jsx(MenuItem, __assign({ value: undefined, disabled: true }, { children: noOptionsText }), "no-opt") })), _jsx(ShowContent, __assign({ show: nonNull(placeholder) && !isEmpty(placeholder) }, { children: _jsx(MenuItem, __assign({ value: '', disabled: true }, { children: placeholder }), "placeholder") })), values === null || values === void 0 ? void 0 : values.map(function (option, index) { return (_jsx(MenuItem, __assign({ value: option.value }, { children: option === null || option === void 0 ? void 0 : option.label }), "opt-".concat(index.toString()))); })] })));
};
